/**
 * resolveEntryId — translate a context (possibly temp) id to the server id
 * recorded in idMap after the first successful save. Used by all five list
 * forms to prevent re-POSTing a temp Date.now() id on follow-up autosaves.
 *
 * @param {Map} idMap  - the idMapRef.current held by the form component
 * @param {*}   id     - the id from context (may be temp or server id)
 * @returns the server-assigned id if one is recorded, otherwise the original id
 */
export function resolveEntryId(idMap, id) {
    return idMap.get(id) ?? id;
}
